<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>服务费明细</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">

                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityAddress" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务站">
                    <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站">
                        <el-option v-for="(item,index) in stationList" :key="index" :label="item.stationName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="服务者姓名">
                    <el-input v-model="listQuery.workerName" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务者编号">
                    <el-input v-model="listQuery.workerNo" placeholder="请输入服务者编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="listQuery.workerTel" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="明细id">
                    <el-input v-model="listQuery.id" placeholder="请输入明细id" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务费类型">
                    <el-select v-model="listQuery.salaryTypes" clearable placeholder="请选择类型"  >
                        <el-option clearable v-for="(item,index) in salaryTypeList" :key="index" :label="item.salaryTypeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否有申诉">
                    <el-select v-model="listQuery.isAppeal" placeholder="请选择是否有申诉" clearable>
                        <el-option :value="0" label="否"></el-option>
                        <el-option :value="1" label="有"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间范围">
                    <el-date-picker v-model="listQuery.entryTime" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>

                    <a href="https://servant.lifejingzhi.com/file/salary/import_salary_template.rar" download="服务费导入模板.rar" >
                      <el-button type="danger" icon="el-icon-download">服务费导入模板下载</el-button>
                    </a>
                        <el-button type="primary" icon="el-icon-upload2"  v-per="'importsalarytype'" @click="uploadBtn">服务费类型导入</el-button>
                         <el-button type="primary" icon="el-icon-download" v-per="'salaryDetailDownload'" @click="downloadSalaryDetail" >导出</el-button>
                    </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="ID" width="80px" fixed="left"></el-table-column>

                <el-table-column prop="workerNo" label="服务者编号" width="120px" fixed="left"></el-table-column>
                <el-table-column prop="workerName" label="姓名"></el-table-column>
                <!-- <el-table-column prop="workerTel" label="手机号"></el-table-column> -->
                <el-table-column prop="entryTime" label="上线日期" width="140px"></el-table-column>
                <el-table-column prop="city" label="城市"></el-table-column>
                <el-table-column prop="station" label="服务站"></el-table-column>
                <el-table-column prop="salaryType" label="类型">
                    <template slot-scope="scope">
                        {{salaryTypeFormat(scope.row.salaryType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="isAppeal" label="是否有申诉">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isAppeal==0">无</span>
                        <span v-if="scope.row.isAppeal==1">有</span>
                    </template>
                </el-table-column>
                <el-table-column prop="dates" label="日期" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="salary" label="金额"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop label="操作" fixed="right" width="150px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showColumnDetail(scope.row)">详情</el-button>

                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="columnDetailVisible" width="800px" :close-on-click-modal="false" center>
            <el-table :data="columnData" border style="width: 100%" class="table">

                <el-table-column :prop="item.key" :label="item.value" v-for="(item,index) in columnList" :key="index"></el-table-column>

            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="columnDetailVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="导入" :visible.sync="inputVisible" width="500px" :close-on-click-modal="false" center>
            <el-row>
                导入类型：
                <el-select v-model="chooseSalaryType" clearable placeholder="请选择类型">
                    <el-option clearable v-for="(item,index) in salaryTypeList" :key="index" :label="item.salaryTypeName" :value="item.id"></el-option>
                </el-select>
            </el-row>
            <br />
            <el-row>
                数据所属月份:
                <el-date-picker v-model="yyyymm" value-format="yyyyMM" type="month" placeholder="选择月份">
                </el-date-picker>
            </el-row><br />
            <el-row>
                选择文件： <input type="file" ref="fileSalary" />
            </el-row><br />
            <span style="color:red;">{{errnoMsg}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="inputVisible = false">取 消</el-button>
                <el-button type="primary" @click="importConfirm">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import Service from "../script/api/service";
import url from "@/script/baseUrl.js";
import globalData from "@/components/common/globaldata/global.data.vue";
export default {
    components: { Pagination },
    data() {
        return {
              exportSalaryDetailUrl:
                url.salaryUrl +
                "/salary/salaryDetailExport?token=" +
                window.localStorage.getItem("token"),
            yyyymm: null,
            errnoMsg: null,
            chooseSalaryType: null,
            inputVisible: false,
            columnDetailVisible: false,
            columnData: [],
            columnList: [],
            cityList: [],
            stationList: [],
            salaryTypeList: [],
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                id: "",
                cityId: "",
                stationId: "",
                workerName: "",
                workerNo: "",
                workerTel: "",
                isAppeal: "",
                salaryTypes: '',
                entryTime: [],
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "今年至今",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近六个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一年",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 12);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    created() {
        this.cityList = JSON.parse(window.localStorage.getItem("allCityList"));
        Service.$axiosGetAllSalaryType()
            .then((res) => {
                this.salaryTypeList = res.data.data;
            })
            .catch((err) => {
                console.log(err);
            });
        if (this.$route.query.id) {
            this.listQuery.id = this.$route.query.id;
        }
         if (this.$route.query.workerNo) {
            this.listQuery.workerNo = this.$route.query.workerNo;
        }
        this.querySearch();
    },
    activated() {
        if (this.$route.query.id) {
            this.listQuery = {
                id: this.$route.query.id,
                cityId: "",
                stationId: "",
                workerName: "",
                workerNo: "",
                workerTel: "",
                isAppeal: "",
                salaryTypes: '',
                entryTime: [],
            };

            this.querySearch();
        }
    },
    methods: {
        downloadSalaryDetail(){
            if (
                this.listQuery.salaryTypes == null ||
                this.listQuery.salaryTypes==''
            ) {
                this.$message.error("选择服务类型");
                return;
            }
            if (
                this.listQuery.cityId == null ||
                this.listQuery.cityId==''
            ) {
                this.$message.error("选择城市");
                return;
            }
            if (
                this.listQuery.entryTime == null ||
                this.listQuery.entryTime.length == 0
            ) {
                this.$message.error("选择时间范围");
                return;
            }
            let startDate = "";
            let endDate = "";
            if (
                this.listQuery.entryTime != "" &&
                this.listQuery.entryTime != undefined
            ) {
                startDate = this.listQuery.entryTime[0];
                endDate = this.listQuery.entryTime[1];
            } 
            //    cityId: this.listQuery.cityId,
            //     stationId: this.listQuery.stationId,
            //     workerName: this.listQuery.workerName,
            //     workerNo: this.listQuery.workerNo,
            //     workerTel: this.listQuery.workerTel,
            //     isAppeal: this.listQuery.isAppeal,
            //     salaryTypes: this.listQuery.salaryTypes,
            let params = `&cityId=${this.listQuery.cityId}&stationId=${this.listQuery.stationId}&workerName=${this.listQuery.workerName}&workerTel=${this.listQuery.workerTel}&startDate=${startDate}&endDate=${endDate}&isAppeal=${this.listQuery.isAppeal}&salaryTypes=${this.listQuery.salaryTypes}`;
            window.open(this.exportSalaryDetailUrl + params);
        },
        importConfirm() {
            if (this.yyyymm == null || this.yyyymm == "") {
                this.$message.error("请选择服务费所属月份");
                return;
            }
            if (
                this.chooseSalaryType == "" ||
                this.chooseSalaryType == null ||
                this.$refs.fileSalary.files.length == 0
            ) {
                this.$message.error("请选导入服务费类型，和上传文件");
                return;
            }

            var formData = new window.FormData();
            formData.append("salaryType", this.chooseSalaryType);
            formData.append("file", this.$refs.fileSalary.files[0]);
            formData.append("yyyymm", this.yyyymm);

            Service.$axiosimportWorkerSalary(formData)
                .then((res) => {
                    // console.log(res);
                    if (res.data.errno == 0) {
                        this.$message.success("导入成功");
                        this.inputVisible = false;
                        this.querySearch();
                    } else {
                        this.errnoMsg = res.data.errmsg;
                        this.$message.error(res.data.errmsg);
                    }
                })
                .catch((err) => {
                    this.errnoMsg = err.data.errmsg;
                });
        },
        uploadBtn() {
            this.inputVisible = true;

            this.yyyymm = null;
            this.errnoMsg = null;
            this.chooseSalaryType = null;

            if (this.$refs.fileSalary) {
                this.$refs.fileSalary.value = null;
            }
        },
        //查询
        querySearch() {
            let temp = {
                id: this.listQuery.id,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                cityId: this.listQuery.cityId,
                stationId: this.listQuery.stationId,
                workerName: this.listQuery.workerName,
                workerNo: this.listQuery.workerNo,
                workerTel: this.listQuery.workerTel,
                isAppeal: this.listQuery.isAppeal,
                salaryTypes: this.listQuery.salaryTypes,
            };
            if (
                this.listQuery.entryTime != "" &&
                this.listQuery.entryTime != undefined
            ) {
                temp.startDate = this.listQuery.entryTime[0];
                temp.endDate = this.listQuery.entryTime[1];
            }

            Service.$axiosSelectSalaryDetailPage(temp)
                .then((res) => {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        salaryTypeFormat(value) {
            const rs = this.salaryTypeList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].salaryTypeName;
            }
        },
        cityChange(value) {
            this.listQuery.stationId = "";
            let currentStation = this.cityList.filter((item) => {
                return item.id == value;
            });
            this.stationList = currentStation[0].stationList;
        },
        dateChange(e) {
            if (e != null) {
                let start =
                    new Date(e[0]).getFullYear() * 12 +
                    new Date(e[0]).getMonth();
                let end =
                    new Date(e[1]).getFullYear() * 12 +
                    new Date(e[1]).getMonth();
                let isOvertime = end - start - 12 > 0;
                // if (isOvertime) {
                //   this.$message.warning("选中时间范围不能超过一年");
                //   this.listQuery.timePart = null;
                // }
            }
        },
        showColumnDetail(row) {
            this.columnDetailVisible = true;
            let salaryType = row.salaryType;
            let current = this.salaryTypeList.filter((item) => {
                return item.id == salaryType;
            });
            let columnAttr = current[0].columnAttr.split(",");
            let columnName = current[0].columnName.split(",");
            let columnList = [];
            let len = columnAttr.length;
            for (let i = 0; i < len; i++) {
                let obj = {
                    key: columnAttr[i],
                    value: columnName[i],
                };
                columnList.push(obj);
            }
            this.columnList = columnList;
            let columnData = [];
            let columnLine = {};
            for (let i = 0; i < len; i++) {
                let itemObj = {
                    [columnAttr[i]]: row[columnAttr[i]],
                };
                Object.assign(columnLine, itemObj);
            }
            columnData.push(columnLine);
            this.columnData = columnData;
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
</style>